import { MouseEvent } from 'react';

import { TableOfContents } from '@/lib/types';

import Link, { LinkVariant } from '@/components/link';
import Typography from '@/components/typography';

export type TableOfContentsItem = {
  title: string;
  url: string;
};

type TableOfContentsProps = {
  links: TableOfContentsItem[];
};

export type ComponentWithTableOfContents = {
  id: string;
  tableOfContents?: TableOfContents | null;
};

export default function TemplateTableOfContents({
  links,
}: TableOfContentsProps) {
  if (links.length === 0) return null;

  const handleItemClick = (item: TableOfContentsItem) => (e: MouseEvent) => {
    const itemElement = document.querySelector(item.url);
    if (!itemElement) return;

    e.preventDefault();
    itemElement.scrollIntoView({ behavior: 'smooth' });
    window.history.pushState(null, '', item.url);
  };

  return (
    <div className='w-full'>
      <div className='mb-10 py-4'>
        <Typography.Heading5 overline>Table of Contents</Typography.Heading5>

        <div className='mt-6 inline-grid gap-4 gap-x-16 lg:grid-cols-2'>
          {links.map((item, index) => (
            <Link
              variant={LinkVariant.LINK}
              key={index}
              href={item.url}
              onClick={handleItemClick(item)}
            >
              {item.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
